import anime from 'animejs';

export function toggleInit(el) {
  const ctx = el instanceof HTMLElement ? el : el.node;
  const circle = ctx.querySelector('circle');
  const lines = [...ctx.querySelectorAll('line')];

  anime.set(circle, { strokeDashoffset: anime.setDashoffset, rotate: -90, transformOrigin: '50% 50% 0' });
  anime.set(lines, { strokeDashoffset: anime.setDashoffset });
}

export function toggleAnim(el, delay = 0) {
  const ctx = el instanceof HTMLElement ? el : el.node;
  const circle = ctx.querySelector('circle');
  const lines = [...ctx.querySelectorAll('line')];
  const tl = anime.timeline({ delay });

  tl.add({
    targets: circle,
    strokeDashoffset: [anime.setDashoffset, 0],
    duration: 800,
    easing: 'easeInOutSine',
  }, 0)
    .add({
      targets: lines,
      strokeDashoffset: [
        { value: 0, duration: 600 },
        {
          value: (line) => parseInt(line.getAttribute('stroke-dasharray'), 10) - 3,
          duration: 800,
        },
      ],
      easing: 'easeInOutSine',
      delay: anime.stagger(50),
    }, '-=800');

  return tl;
}

export function togglePlay(el, delay = 0) {
  const ctx = el instanceof HTMLElement ? el : el.node;
  const lines = [...ctx.querySelectorAll('line')];

  anime.remove(lines);
  const randomValues = () => anime({
    targets: lines,
    strokeDashoffset: (line) => [parseInt(line.getAttribute('stroke-dasharray'), 10) - 3, 0],
    easing: 'linear',
    direction: 'alternate',
    duration: () => anime.random(400, 800),
    delay: anime.stagger(50, { start: delay }),
    complete: randomValues,
  });

  return randomValues();
}

export function togglePause(el, delay = 0) {
  const ctx = el instanceof HTMLElement ? el : el.node;
  const lines = [...ctx.querySelectorAll('line')];

  anime.remove(lines);
  const tween = anime({
    targets: lines,
    strokeDashoffset: (line) => parseInt(line.getAttribute('stroke-dasharray'), 10) - 3,
    easing: 'easeInOutSine',
    duration: 800,
    delay: anime.stagger(50, { start: delay }),
  });

  return tween;
}
